import type { TFunction } from "i18next";


interface ElectionResultsNoticeProps {
  nextElectionStartDate: string;
  formatDate: (dateString: string | null | undefined) => string;
  formatNextElectionTimeRemaining: (nextElectionStartDate: string | null | undefined) => string;
  t: TFunction;
}

/** Banner when voting is closed but next election date is known. */
function ElectionResultsNotice({
  nextElectionStartDate,
  formatDate,
  formatNextElectionTimeRemaining,
  t,
}: ElectionResultsNoticeProps) {
  return (
    <div className="rounded-md bg-white-alpha-80 px-xl py-lg [font-family:Lato,sans-serif] text-[14px] text-text-dark">
      {t("Elections have recently ended, you can review the results below")}
      {(() => {
        const timeRemaining = formatNextElectionTimeRemaining(nextElectionStartDate);
        return timeRemaining ? (
          <div className="mt-xs font-bold">
            {t("Date of the next Mayor election start:")}{" "}
            <span className="[direction:ltr] [unicode-bidi:isolate]">
              {formatDate(nextElectionStartDate)} ({timeRemaining})
            </span>
          </div>
        ) : null;
      })()}
    </div>
  );
}

export default ElectionResultsNotice;
